import type { CampaignCoverImage, YammerState } from '../../state/types';
import { createFindById, createFindByIdThrows } from '../findById';
import type { FindById, FindByIdThrows } from '../findById';

export const findById: FindById<'campaignCoverImages'> = createFindById('campaignCoverImages');
export const findByIdThrows: FindByIdThrows<'campaignCoverImages'> = createFindByIdThrows('campaignCoverImages');

type GetFulfilledCampaignCoverImages = (state: YammerState) => Record<string, CampaignCoverImage>;
/**
 * @deprecated PERFORMANCE This returns a new object any time any campaign cover image changes and forces unnecessary re-renders.
 * Consuming components which need all or multiple campaigns should only select a memoized list of ids, then pass
 * each id to individual child components which can select the specific campaign fields they require and manage
 * their own component-level memoization to avoid unnecessary re-renders.
 */
export const getFulfilledCampaignCoverImages: GetFulfilledCampaignCoverImages = (state) =>
  state.campaignCoverImages.fulfilled.byId;
